module.exports = __webpack_public_path__ + "img/p-single-8.3c701b76.jpg";